import { cx } from "@emotion/css";
import type { FC, ReactElement } from "react";

import BuildingTwoIcon from "@/assets/building-2.svg?react";
import HeadCountIcon from "@/assets/headcount.svg?react";
import HouseIcon from "@/assets/house.svg?react";
import PlacePinIcon from "@/assets/place-pin.svg?react";
import { Card } from "@/components";
import type { LongTextVariant } from "@/components/text/LongText";
import LongText from "@/components/text/LongText";
import type { Building } from "@/types";

interface IBuildingCardProps {
  building: Building;
  titleLighted?: boolean;
  className?: string;
  onClick?: () => void;
}

export default function LiteBuildingCard({ className, building, titleLighted, onClick }: Readonly<IBuildingCardProps>) {
  return (
    <Card className={cx("my-3", className)} onClick={onClick}>
      <p className={cx("text-base font-semibold text-[#303333]", "mb-[0.625rem]", titleLighted && "text-primary")}>
        <LongText variant="multilineFull" text={building.property_name || ""} />
      </p>
      <BuildingCardItem
        attributeName="棟名"
        icon={<BuildingTwoIcon className="mb-[2px] mr-[10px] inline" />}
        content={building.name}
      />
      <BuildingCardItem
        attributeName="仮称名称"
        icon={<HouseIcon className="mb-[2px] mr-[10px] inline" />}
        content={building?.property_alias}
        style="line"
      />
      <BuildingCardItem
        attributeName="住所"
        icon={<PlacePinIcon className="mb-[2px] mr-[10px] inline" />}
        content={building.address?.full_address}
      />
      <BuildingCardItem
        attributeName="戸数"
        icon={<HeadCountIcon className="mb-[2px] mr-[10px] inline" />}
        content={building?.actual_households}
      />
    </Card>
  );
}
interface IBuildingCardItemProps {
  attributeName: string;
  icon: ReactElement;
  content?: string | number;
  longTextVariant?: LongTextVariant;
  style?: "default" | "line";
}

const BuildingCardItem: FC<IBuildingCardItemProps> = ({
  attributeName,
  content,
  icon,
  longTextVariant = "multilineFull",
  style = "default",
}) => {
  return style === "line" ? (
    <div className={cx("text-sm text-neutral-600")}>
      <span>
        {icon}
        {attributeName}：
      </span>
      <span>{content || "-"}</span>
    </div>
  ) : (
    <p className={cx("flex items-start", "text-sm leading-[22px] text-neutral-600")}>
      <span className="shrink-0">
        {icon}
        {attributeName}：
      </span>
      <span className="min-w-0 flex-1">
        <LongText variant={longTextVariant} text={content || "-"} />
      </span>
    </p>
  );
};
